const normalizeStage = (value) =>
  String(value || "")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const STAGE_COLOR_RULES = [
  {
    match: /\b(reject\w*|declin\w*|fail\w*|fake|withdraw\w*)\b|\bnot (interested|suitable|selected)\b/,
    hue: 350, span: 24,
  },
  {
    match: /\bnot spoken\b|\b(no response|voicemail|vm|nr|pending|on hold|project end|closed)\b/,
    hue: 225, span: 15, saturation: 15,
  },
  { match: /\b(join\w*|hired|placed|onboard\w*)\b/, hue: 120, span: 35 },
  { match: /\boffer\w*\b/, hue: 160, span: 10 },
  { match: /\bshortlist\w*\b|\bselect\w*\b/, hue: 220, span: 25 },
  { match: /\binterview\w*\b/, hue: 25, span: 25 },
  { match: /\bpropos\w*\b|\bsubmit\w*\b/, hue: 265, span: 55 },
  { match: /\binterested\b/, hue: 175, span: 15 },
  { match: /\bspoken\b|\bcontact\w*\b|\bto track\b/, hue: 195, span: 20 },
  { match: /\bnew\b|\bprofile\b|\bsourc\w*\b/, hue: 205, span: 15, saturation: 25 },
];

const getStageRule = ({ stage, systemKey }) => {
  const name = normalizeStage(stage);
  const key = normalizeStage(systemKey);
  const rejection = STAGE_COLOR_RULES[0];

  if (rejection.match.test(name) || rejection.match.test(key)) return rejection;

  return STAGE_COLOR_RULES.find(({ match }) => match.test(name)) ||
    STAGE_COLOR_RULES.find(({ match }) => match.test(key));
};

export const generateFunnelColors = (stages) => {
  const groups = new Map();
  const colors = new Array(stages.length);
  const usedColors = new Set();

  stages.forEach((stage, index) => {
    const rule = getStageRule(stage);
    if (!groups.has(rule)) groups.set(rule, []);
    groups.get(rule).push({
      index,
      identity: normalizeStage(stage.systemKey || stage.stage),
    });
  });

  groups.forEach((members, rule) => {
    members.sort((a, b) => a.identity.localeCompare(b.identity));
    members.forEach(({ index }, variant) => {
      const position = members.length === 1 ? 0.5 : variant / (members.length - 1);
      const hue = rule
        ? (rule.hue + rule.span * position) % 360
        : (280 + variant * 137.50776405003785) % 360;
      const saturation = rule ? (rule.saturation ?? 72) : 58;
      let lightness = variant % 2 === 0 ? 42 : 60;
      let color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      while (usedColors.has(color)) {
        lightness += 0.01;
        color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      }
      usedColors.add(color);
      const lightColor = `hsl(${hue}, ${saturation + 6}%, ${lightness + 12}%)`;
      colors[index] = {
        color,
        gradient: `linear-gradient(90deg, ${color} 0%, ${lightColor} 100%)`,
      };
    });
  });

  return colors;
};
